'use client';

import React from 'react';
import PropTypes from 'prop-types';

import PromotionContentContext from './PromotionContentContext';

// Provides server-fetched promotion content to the header/page subtree so the
// default `useContentfulPromotionContent()` calls resolve without Apollo on the
// client. `value` is plain serialisable data fetched in the (cached) root
// layout — see consumer `src/utils/server/getPromotionContent.js` (CON-8210).
const PromotionContentProvider = ({ value = null, children }) => (
  <PromotionContentContext.Provider value={value}>
    {children}
  </PromotionContentContext.Provider>
);

PromotionContentProvider.propTypes = {
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.oneOf([null])]),
  children: PropTypes.node,
};

export default PromotionContentProvider;
